import React, {useEffect, useState} from 'react';
import axios from "axios";
import opsToast from "../../ops-library/ops-toast";
import {Modal} from "react-bootstrap";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {FaTrashCan} from "react-icons/fa6";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import OpsInput from "../../ops-library/ops-input";
import {BiShow, BiSolidEdit} from "react-icons/bi";
import {LoadingSpinner} from "../LoadingSpinner";
import {useNavigate} from "react-router-dom";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {FaPlus} from "react-icons/fa";
import {FiFilter} from "react-icons/fi";
import OpsTable from "../../ops-library/ops-table";
import OpsIconStatus from "../../ops-library/ops-icon-status";
import {TbRestore} from "react-icons/tb";
import OpsToast from "../../ops-library/ops-toast";

const AdminUsers = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [users, setUsers] = useState(null)
    const [showDeleted, setShowDeleted] = useState(false)
    const [modalUserShown, setModalUserShown] = useState(false);
    const [loading, setLoading] = useState(true)
    const [modalDataUser, setModalDataUser] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (!hasRoleAccess(sectionId, user.role))
            navigate("/")
        getUsers()
    }, []);

    function getUsers(showDeleted = false) {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/auth/getAllUsers?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };


        axios(configuration)
            .then((result) => {
                setUsers(result.data.content)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    function restoreUser(userID) {
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/restore/${userID}?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },

        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setUsers(result.data.content)
                    OpsToast("Účet používateľa bol obnovený!", "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function handleOpenModalUser(data) {
        if (data) {
            setModalUserShown(true);
            setModalDataUser(data);
        } else {
            setModalUserShown(true);
            setModalDataUser(null);
        }
    }

    function handleModalsClose() {
        setModalUserShown(false);
        setModalDataUser(null)
    }

    const ModalEmployee = ({show = false, onHide}) => {

        const [forename, setForename] = useState(modalDataUser?.forename ?? "");
        const [surname, setSurname] = useState(modalDataUser?.surname ?? "");
        const [email, setEmail] = useState(modalDataUser?.email ?? "");
        const [systemAdmin, setResortOwner] = useState(modalDataUser?.role === "system-admin");
        const [admin, setAdmin] = useState(modalDataUser?.role === "admin");
        const [member, setMember] = useState(modalDataUser?.role === "member");
        const [processed, setProcessed] = useState(false);

        function handleEditUser(userID) {
            setProcessed(true)
            let role = ""
            if (systemAdmin)
                role = "system-admin"
            if (admin)
                role = "admin"
            if (member)
                role = "member"

            const configuration = {
                method: 'patch',
                url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/edit/${userID}?includeDeleted=${showDeleted}`,
                data: {
                    forename: forename,
                    surname: surname,
                    email: email,
                    role: role
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    if (result.data.content !== undefined) {
                        setUsers(result.data.content)
                        OpsToast(result?.data?.message, "success")
                    }
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });

            setProcessed(false)
        }

        function handleRegisterUser() {
            if (forename.length === 0) {
                opsToast("Nezadali ste meno používateľa!", "error", "colored", true, "top-center")
            } else if (surname.length === 0) {
                opsToast("Nezadali ste priezvisko používateľa!", "error", "colored", true, "top-center")
            } else if (email.length === 0) {
                opsToast("Nezadali ste email používateľa!", "error", "colored", true, "top-center")
            } else {
                setProcessed(true)
                let role = ""
                if (systemAdmin)
                    role = "system-admin"
                if (admin)
                    role = "admin"
                if (member)
                    role = "member"

                const configuration = {
                    method: 'post',
                    url: `${process.env.REACT_APP_API_BASE_URL}/auth/register?includeDeleted=${showDeleted}`,
                    data: {
                        forename: forename,
                        surname: surname,
                        email: email,
                        emailVerified: false,
                        role: role
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }

                axios(configuration)
                    .then((result) => {
                        if (result.data.content !== undefined) {
                            setUsers(result.data.content)
                            OpsToast(result?.data?.message, "success")
                        }
                        handleModalsClose();
                    })
                    .catch((error) => {
                        console.log(error)
                        opsToast(error.message, "error", "colored", true, "top-center");
                    });
                setProcessed(false)
            }
        }

        function handleDeleteUser(userID) {
            setProcessed(true)
            const configuration = {
                method: 'delete',
                url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/delete/${userID}?includeDeleted=${showDeleted}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    if (result.data.content !== undefined) {
                        setUsers(result.data.content)
                        OpsToast(result?.data?.message, "success")
                    }
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton
                              className="modal-background-color">
                    <div className="fa-flex-row justify-content-between w-100 h-100">
                        <OpsText type="title" weight={700} color="primary-3" alignment="left"
                                 content={modalDataUser ? `${modalDataUser.forename} ${modalDataUser.surname}` : "Vytvorenie účtu"}/>
                        {modalDataUser && <OpsBtn
                            icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                            variant="icon me-2"
                            padding={false}
                            action={() => {
                                const actual_employee = modalDataUser;
                                handleModalsClose()
                                opsConfirmDialog(
                                    "Zmazanie používateľa",
                                    `Naozaj si prajete vymazať používateľa ${actual_employee.forename} ${actual_employee.surname}?`,
                                    theme,
                                    () => handleDeleteUser(actual_employee._id),
                                    () => handleOpenModalUser(actual_employee)
                                )
                            }}
                        />}
                    </div>
                </Modal.Header>

                {processed ?
                    <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                        <LoadingSpinner/>
                    </Modal.Body>
                    :
                    <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                        <div className="custom-modal-content justify-content-between">
                            {/*MENO, PRIEZVISKO, EMAIL*/}
                            <div className="fa-flex-col mb-4">
                                <OpsInput
                                    required
                                    id="employee-fename"
                                    label="Meno"
                                    placeholder="napr. Janko"
                                    value={forename}
                                    onChange={(e) => setForename(e.target.value)}
                                />
                                <OpsInput
                                    required
                                    id="employee-surname"
                                    label="Prezvisko"
                                    placeholder="napr. Hraško"
                                    value={surname}
                                    onChange={(e) => setSurname(e.target.value)}
                                />
                                <OpsInput
                                    required
                                    id="employee-email"
                                    type="email"
                                    label="E-mailová adresa"
                                    placeholder="napr. janko@hrasko.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div className="fa-flex-col mb-3 gap-2">
                                <OpsInput id="webUser-check" customType="checkBox"
                                          label="admin systému"
                                          labelColor="color-1"
                                          value={systemAdmin}
                                          onChange={() => setResortOwner(!systemAdmin)}/>
                                <OpsInput id="resortManager-check" customType="checkBox"
                                          label="admin"
                                          labelColor="color-1"
                                          value={admin}
                                          onChange={() => setAdmin(!admin)}/>
                                <OpsInput id="resortMarketing-check" customType="checkBox"
                                          label="člen"
                                          labelColor="color-1"
                                          value={member}
                                          onChange={() => setMember(!member)}/>
                            </div>


                            <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                                <OpsBtn
                                    text="Zahodiť"
                                    variant="secondary"
                                    size="md mt-2"
                                    action={() => handleModalsClose()}
                                />
                                {modalDataUser ?
                                    <OpsBtn
                                        text="Upraviť"
                                        variant="primary"
                                        size="md mt-2"
                                        action={() => handleEditUser(modalDataUser._id)}
                                    />
                                    :
                                    <OpsBtn
                                        text="Registrovať"
                                        variant="primary"
                                        size="md mt-2"
                                        action={() => handleRegisterUser()}
                                    />
                                }
                            </div>
                        </div>
                    </Modal.Body>}
            </Modal>
        )
    }

    return (
        <div className="adm-section" id="staff">
            <ModalEmployee show={modalUserShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="Správa používateľov"/>

            {/* SPRAVA POUZIVATELOV */}
            <div className="adm-container fa-flex-col">
                <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                    <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                             content="Používatelia"/>
                    <div className="fa-flex-row">
                        {/*VYTVORIT UCET<*/}
                        <OpsBtn
                            id="tbl-create"
                            tooltipText="Vytvoriť účet"
                            icon={<FaPlus color="var(--color-p-300)"
                                          className="ops-icon-sm m-1 mx-3"/>}
                            variant="icon mx-1"
                            backgroundColor="bg-3 border border-1"
                            padding={false}
                            action={() => {
                                handleOpenModalUser()
                            }}
                        />
                        {/*ZOBRAZIT AJ ZMAZANE*/}
                        <OpsBtn
                            id="tbl-filter-deleted"
                            tooltipText="Zobraziť zmazaných používateľov"
                            icon={<FiFilter color={!showDeleted ? "var(--color-p-300)" : "var(--color-1)"}
                                            className="ops-icon-sm m-1"/>}
                            variant="icon mx-1"
                            backgroundColor={`${!showDeleted ? 'bg-3' : 'bg-primary-3'} border border-1`}
                            padding={false}
                            action={() => {
                                setShowDeleted(!showDeleted)
                                getUsers(!showDeleted)
                            }}
                        />
                    </div>
                </div>
                {/*HLAVNA TABUĽKA*/}
                <OpsTable
                    id="users"
                    name=""
                    theme={theme}
                    classname=""
                    columns={[
                        {
                            name: "Registrácia",
                            selector: row => new Date(row.createdAt).getTime(),
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${new Date(row.createdAt).toLocaleDateString('sk-SK', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }).replace(/\s/g, '')} - ${new Date(row.createdAt).toLocaleTimeString('sk-SK', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })}`}
                                />
                            )
                        },
                        {
                            name: "Meno a priezvisko",
                            selector: row => row.forename,
                            sortable: true,
                            width: '20%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${row.forename} ${row.surname}`}
                                />
                            )
                        },
                        {
                            name: "Email",
                            selector: row => row.email,
                            sortable: false,
                            width: '25%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.email}
                                />
                            )
                        },
                        {
                            name: "Rola",
                            selector: row => row.role,
                            sortable: false,
                            width: '10%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.role}
                                />
                            )
                        },
                        {
                            name: "Posl. prihlásenie",
                            selector: row => new Date(row.lastLoggedIn).getTime(),
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${new Date(row.lastLoggedIn).toLocaleDateString('sk-SK', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }).replace(/\s/g, '')} - ${new Date(row.createdAt).toLocaleTimeString('sk-SK', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })}`}
                                />
                            )
                        },
                        {
                            name: "",
                            selector: row => row.emailVerified,
                            sortable: false,
                            width: '5%',
                            center: true,
                            cell: (row) =>
                                <OpsIconStatus
                                    status={row.emailVerified === true ? 'completed' : ''}/>
                        },
                        {
                            name: "",
                            sortable: false,
                            selector: null,
                            width: '10%',
                            cell: (row) => [
                                !row.deleted && <OpsBtn
                                    key={0}
                                    icon={<BiSolidEdit className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={row.deleted ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => handleOpenModalUser(row)}
                                />,
                                row.deleted && <OpsBtn
                                    key={1}
                                    icon={<TbRestore className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor="bg-g-2"
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Obnovenie používateľa",
                                            `Naozaj si prajete obnoviť používateľa?`,
                                            theme,
                                            () => restoreUser(row._id),
                                            () => null
                                        )
                                    }}
                                />
                            ]
                        }
                    ]}
                    data={loading === false ? users : []}
                />
            </div>

            {/*<div className="desktop-row-phone-col justify-content-between gap-3">*/}
            {/*    <OpsText type="normal4 my-1" weight={700} color="primary-6" alignment="left"*/}
            {/*             content={`Používatelia`}/>*/}
            {/*    <OpsBtn*/}
            {/*        text="Vytvoriť účet"*/}
            {/*        variant="primary"*/}
            {/*        textSize="md"*/}
            {/*        size="md-2"*/}
            {/*        action={() => handleOpenModalUser()}*/}
            {/*    />*/}
            {/*</div>*/}

            {/*{users !== null ?*/}
            {/*    <div className="adm-content">*/}
            {/*        <div className="adm-list-bg scroll scroll2">*/}
            {/*            {users?.map((person, index) => (*/}
            {/*                <div className="desktop-row-phone-col my-1 gap-2" key={index}>*/}
            {/*                    <div className='adm-list-item p-2 justify-content-between'>*/}
            {/*                        <OpsText type="label" weight={600} alignment="left"*/}
            {/*                                 content={`${person.forename} ${person.surname}`}/>*/}
            {/*                        /!*  ikonky  *!/*/}
            {/*                    </div>*/}

            {/*                    <div className="fa-flex-row adm-list-btn">*/}
            {/*                        <OpsBtn*/}
            {/*                            leftIcon={<BiSolidEdit color="var(--color-g-1)"*/}
            {/*                                                   className="ops-icon-sm-2 me-2 phone-not-shown"/>}*/}
            {/*                            variant="outline"*/}
            {/*                            padding={false}*/}
            {/*                            text="Editovať"*/}
            {/*                            textColor="color-g-1 px-2"*/}
            {/*                            action={() => handleOpenModalUser(person)}*/}
            {/*                        />*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    :*/}
            {/*    <div className="adm-content py-5">*/}
            {/*        <LoadingSpinner/>*/}
            {/*    </div>*/}
            {/*}*/}
        </div>
    )
}

export default AdminUsers;